import { updateKeyInStore } from 'App';
import * as Yup from 'yup';
import { store } from 'app/redux/store';

import {
  CompensationStateValues,
  updateKey,
  updateFieldArrayKey,
} from './slice';

export const fields: IBaseField<keyof CompensationStateValues | any>[] = [
  {
    name: 'doYouHaveEmployees',
    label: 'Do you have employees?',
    type: 'radio',
    effect: updateKeyInStore(updateKey),
    tooltip: '',
    comment: true,
  },
  {
    name: 'didYouOfferMedicalInsuranceToAnyEmployeesDuringThisYear',
    label: 'Did you offer medical insurance to any employees during this year?',
    type: 'radio',
    effect: updateKeyInStore(updateKey),
    comment: true,
    predicate: (v) => v === 'yes',
    dependencies: [
      {
        name: 'didYouPayAllWagessalariesAndWithholdAllRequiredTaxes',
        label:
          'Did you pay all wages/salaries and withhold all required taxes?',
        type: 'radio',
        effect: updateKeyInStore(updateKey),

        comment: true,
        predicate: (v) => v === 'yes',

        dependencies: [
          {
            name: 'doesYourBusinessOfferARetirementPlanForEmployees',
            label: 'Does your business offer a retirement plan for employees?',
            type: 'radio',
            effect: updateKeyInStore(updateKey),

            predicate: (v) => v === 'yes',

            comment: true,
            dependencies: [
              {
                name: 'doesYourBusinessOfferAnHsaAccountForEmployees',
                label: 'Does your business offer an HSA account for employees?',
                type: 'radio',
                effect: updateKeyInStore(updateKey),
                comment: true,
                predicate: (v) => v === 'yes',

                dependencies: [
                  {
                    name: 'doesYourBusinessOfferACafeteria124FlexibleSpendingAccountForEmployees',
                    label:
                      'Does your business offer a Cafeteria 124/ flexible Spending account for employees?',
                    type: 'radio',
                    effect: updateKeyInStore(updateKey),
                    comment: true,
                    predicate: (v) => v === 'yes',
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },

  {
    name: 'doesYourBusinessHaveMoreThan50Employees',
    label: 'Does your business have more than 50 employees?',
    type: 'radio',
    effect: updateKeyInStore(updateKey),
    tooltip: '',
    comment: true,
  },
  {
    name: 'didYouPayAnyEmployeesQualifiedFamilyLeaveWages',
    label: 'Did you pay any employees qualified family leave wages?',
    type: 'radio',
    effect: updateKeyInStore(updateKey),
    tooltip: '',
    comment: true,
  },
  {
    name: 'didYouPayAnyEmployeesQualifiedSickLeaveWages',
    label: 'Did you pay any employees qualified sick leave wages?',
    type: 'radio',
    effect: updateKeyInStore(updateKey),
    tooltip: '',
    comment: true,
  },
  {
    name: 'pleaseUploadAllPayrollSummaryReportsPayrollDetailReportsW2SAndW3S',
    label:
      'Please upload all Payroll Summary reports, Payroll Detail reports, W2s and W3s.',
    type: 'upload',
    effect: updateKeyInStore(updateKey),
    tooltip: '',
    comment: true,
  },
  {
    name: 'didYouPayAnyoneWhoIsNotACorporationATotalOf600OrMoreDuringTheYearOrIfYouPaidAnyAmountToAnyAttorneysYouAreRequiredToIssueEachPayeeA1099MiscForm',
    label:
      'Did you pay anyone, who is not a corporation, a total of $600 or more during the year, or if you paid any amount to any attorneys? You are required to issue each payee a 1099 Misc form.',
    type: 'radio',
    effect: updateKeyInStore(updateKey),
    tooltip: '',
    comment: true,
  },
  {
    name: 'didYouMakeAnyPaymentsForWhichYouShouldIssueA1099Misc',
    label: 'Did you make any payments for which you should issue a 1099 Misc?',
    type: 'radio',
    effect: updateKeyInStore(updateKey),
    tooltip: '',
    comment: true,
  },
  {
    name: 'didYouIssueTheRequired1099MiscForms',
    label: 'Did you issue the required 1099 Misc forms?',
    type: 'radio',
    effect: updateKeyInStore(updateKey),
    tooltip: '',
    comment: true,
  },
  {
    name: 'howManyForms1099AreYouRequiredToFileForPaymentsYouMadeThisYear',
    label:
      'How many Form(s) 1099 are you required to file for payments you made this year?',
    type: 'number',
    effect: updateKeyInStore(updateKey),
    tooltip: '',
    comment: true,
  },
  {
    name: 'didYouPayYourselfOrAnyWorkersAsEmployeesThisYear',
    label: 'Did you pay yourself or any workers as employees this year?',
    type: 'radio',
    effect: updateKeyInStore(updateKey),
    tooltip: '',
    comment: true,
  },
  {
    name: 'didYouHaveAProfessionalAtAccountantsOnAirProcessYourPayrollThisYear',
    label:
      'Did you have a professional at Accountants On Air process your payroll this year?',
    type: 'radio',
    effect: updateKeyInStore(updateKey),
    comment: true,
    dependencies: [
      {
        name: 'congratulationsThatMeansMuchLessWorkForYouOnThisTaxInformationweWillImportYourPayrollInformationDirectlyFromOurPayrollSoftware',
        label: () =>
          'Congratulations! That means much less work for you on this tax information!\nWe will import your payroll information directly from our payroll software.',
        type: 'information',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'yes',
      },
      {
        name: 'didYouKnowWeOfferPayrollServicesifInterestedPleaseAskYourTaxAdvisorForMoreDetails',
        label: 'Do you want to hire AOA to process your payroll this year?',
        type: 'radio',
        effect: updateKeyInStore(updateKey),

        comment: true,
        predicate: (v) => v === 'no',
        dependencies: [
          {
            type: 'information',
            predicate: (v) => v === 'yes',
            label: () => (
              <a
                target="_blank"
                href="https://app.acuityscheduling.com/schedule.php?owner=14032819"
                className="text-green font-semibold hover:underline"
                rel="noreferrer"
              >
                Speak to a specialist right now
              </a>
            ),
          },
        ],
      },
    ],
  },

  {
    name: 'howManyFormsW2W3DidYouReceiveThisYear',
    label: 'How many Form(s) W-2 / W-3 did you receive this year?',
    type: 'number',
    effect: updateKeyInStore(updateKey),
    tooltip: '',
    comment: true,
  },
  {
    name: 'didYouPurchaseAnyBusinessAssetsThisYear',
    label: 'Did you purchase any business assets this year?',
    type: 'radio',
    effect: updateKeyInStore(updateKey),
    tooltip: '',
    comment: true,
    dependencies: [
      {
        name: 'describeAssetsYouPurchased',
        label: 'Describe Assets you purchased',
        type: 'fieldArray',
        dependencies: [
          {
            name: 'description',
            label: 'Description',
            type: 'text',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
          {
            name: 'datePlacedInService',
            label: 'Date placed in service',
            type: 'date',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
          {
            name: 'purchasedPrice',
            label: 'Purchased Price',
            type: 'number',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
          },
          {
            name: 'didYouMakeImprovementsOrRepairsToAnyPropertyEquipmentOrOtherAssets',
            label:
              'Did you make improvements or repairs to any property, equipment or other assets?',
            type: 'radio',
            effect: updateKeyInStore(updateKey),
            tooltip: '',
            comment: true,
            dependencies: [
              {
                name: 'pleaseProvideDetailsAndCosts',
                label: 'Please provide details and costs',
                type: 'text',
                effect: updateKeyInStore(updateKey),
                comment: true,
                predicate: (v) => v === 'yes',
              },
            ],
          },
        ],
        defaultDependency: {},
        effect: (payload) => store.dispatch(updateFieldArrayKey(payload)),
        predicate: (v) => v === 'yes',
        comment: true,
      },
    ],
  },
];

export const validationSchema = Yup.object().shape({});
